import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ProductDeclineForm, { IStateProps, IDispatchProps, IOwnProps } from './ProductDeclineForm'
import { DashboardAction, requestProductDecline } from '../../services/store/actions/dashboard/DashboardAction'
import { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(): IStateProps {
  return { }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    requestProductDecline: (product, declineData) => dispatch(requestProductDecline({product, declineData})),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(ProductDeclineForm)
